"use strict";

require("./_related-products");